<template>
  <div class>
    <div class v-for="(question, index) in activityQuestions.filter((activityQuestion, ind) => activityQuestion.classType !== 'CompletionQuestion' && ind >= startIndex && ind < endIndex)" :key="index">
      <template v-if="question.type === 'Section'">
        <div class="group-scoring__container mb-10 group-scoring__container-filled h-30 p-5 pl-13">
          <span class="color-white fs-14">{{ question.title }}</span>
        </div>
      </template>
      <template v-if="question.type !== 'Section'">
        <div class="card read_only_question" v-if="selectedActivityQuestion.id !== question.id">
          <div class="row">
            <div class="col-md-4 p-0">
              <p class="question_color">
                Step
                <span class>{{ question.stepSequence }}:</span>
              </p>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 p-0">
              <div class="question-section">
                <div v-if="question.type === 'SurveyInstruction' || question.type === 'GPSkin' || question.type === 'ImageCapture'">
                  <div v-if="!question.templateImageUrl">
                    <div v-if="question.type === 'SurveyInstruction' || question.type === 'ImageCapture' || question.type === 'GPSkin'" class="instruction_title ql-editor pt-0 p-0" v-html="question.formattedTitle"></div>
                    <div class="instruction_info ql-editor pt-5 p-0 step-img-format" v-html="question.formattedInformation"></div>
                    <div class="row">
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <div v-if="question.imageUrl">
                          <img class="img-size" :src="question.imageUrl" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="question.type === 'SurveyInstruction' || question.type === 'ImageCapture'" class="instruction_title ql-editor pt-0 p-0" v-html="question.formattedTitle"></div>
                    <div class="instruction_info ql-editor pt-6 p-0" v-html="question.formattedInformation"></div>
                    <div class="row">
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <div v-if="question.imageUrl">
                          <img class="img-size" :src="question.imageUrl" />
                        </div>
                      </div>
                      <div class="col-sm-6 col-md-6 col-lg-6">
                        <div class="font_bold p-0">
                          <p>Template Image</p>
                        </div>
                        <div v-if="question.templateImageUrl">
                          <img class="img-size" :src="question.templateImageUrl" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class v-if="question.hasBodyImage">
                    <div class v-for="(img, index) in question.bodyImages" :key="index">
                      <img :src="img.imageUrl" alt class="wid300" />
                    </div>
                  </div>

                  <div class="answer-section">
                    <div v-if="question.type.toLowerCase() === 'measurements'" class="option-section">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div v-if="question.measurementUnit != 'Feet-Inches' && question.subType != 'bloodpressure'">
                        <input type="text" class="input-text readonly col-md-3 weight_input" :placeholder="getplaceholdertext(question)" readonly />
                        <span class="ml-10">{{ question.measurementUnit }}</span>
                      </div>
                      <div v-if="question.measurementUnit == 'Feet-Inches'">
                        <input type="text" class="input-text readonly col-md-3 weight_input" :placeholder="getplaceholdertext(question)" readonly />
                        <span class="ml-10 mr-10">ft</span>
                        <input type="text" class="input-text readonly col-md-3 weight_input" :placeholder="getplaceholdertext(question)" readonly />
                        <span class="ml-10 mr-2">in</span>
                      </div>
                      <div v-if="question.subType === 'bloodpressure'">
                        <input type="text" class="input-text readonly col-md-3" placeholder="Systolic value" readonly />
                        <span class="ml-10 mr-10">mmHg</span>
                        <input type="text" class="input-text readonly col-md-3" placeholder="Diastolic value" readonly />
                        <span class="ml-10 mr-2">mmHg</span>
                      </div>
                    </div>
                    <div class="option-section" v-if="question.type.toLowerCase() === 'boolean'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div class v-for="(option, index) in question.options" :key="index">
                        <p class="radio-option">
                          <input type="radio" name="boolean_type" disabled />
                          <label>{{ option.body }}</label>
                        </p>
                      </div>
                    </div>
                    <div class="option-section pad-top20" v-if="question.type && question.type.toLowerCase() === 'numberscale'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div v-if="!question.verticalScale" :class="!!question.numericRatingScale ? 'd-inline-block' : ''">
                        <div v-if="activityData && activityData.newLayout == true">
                          <div class="row">
                            <div class="pl-0 pr-7 col-md-2">
                              {{ question.minValueLabel }}
                            </div>
                            <ds-slider
                              ref="slider"
                              v-if="question.partitions !== 0"
                              :value="question.minValue"
                              :piecewise="true"
                              direction="horizontal"
                              class="horizontal-vue-slider pt-30 col-md-8"
                              :min="question.minValue"
                              :max="question.maxValue"
                              :disabled="true"
                              :piecewiseLabel="true"
                              :piecewiseStyle="piecewiseStyle"
                              :interval="question.partitions"
                              :piecewiseActiveStyle="null"
                              :labelActiveStyle="null"
                              :dotSize="0"
                              :isNumericRatingScale="!!question.numericRatingScale"
                              :defaultSelected="false"
                            ></ds-slider>
                            <ds-slider ref="slider" v-else :value="question.minValue" direction="horizontal" class="horizontal-vue-slider pt-30 col-md-8" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="null" :dotSize="0"></ds-slider>
                            <div class="pr-0 col-md-2">
                              {{ question.maxValueLabel }}
                            </div>
                          </div>
                        </div>
                        <div v-else :class="{ 'd-flex flex-column': !!question.numericRatingScale }">
                          <ds-slider
                            ref="slider"
                            v-if="question.partitions !== 0"
                            :value="question.minValue"
                            :piecewise="true"
                            direction="horizontal"
                            class="horizontal-vue-slider mb-30"
                            :class="{ 'act-step-box-slider': !!question.numericRatingScale }"
                            :min="question.minValue"
                            :max="question.maxValue"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :interval="question.partitions"
                            :piecewiseActiveStyle="null"
                            :labelActiveStyle="null"
                            :dotSize="0"
                            :isNumericRatingScale="!!question.numericRatingScale"
                            :defaultSelected="false"
                          ></ds-slider>
                          <ds-slider ref="slider" v-else :value="question.minValue" direction="horizontal" class="horizontal-vue-slider pl-20 mb-30" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="null" :dotSize="0"></ds-slider>
                          <div class="pt-10 scaleLabels d-flex justify-content-between">
                            <div class="pull-left label">
                              {{ question.minValueLabel }}
                            </div>
                            <div class="pull-right label text-right wordbrk right-label">
                              {{ question.maxValueLabel }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="question.verticalScale">
                        <div class="scaleLabels text-center w-120">
                          {{ question.maxValueLabel }}
                        </div>
                        <ds-slider
                          ref="slider"
                          v-if="question.partitions !== 0"
                          :value="question.minValue"
                          :piecewise="true"
                          direction="vertical"
                          class="vertical-vue-slider pl-20 mt-10"
                          :class="{ 'v-number-scale-steps': !question.numericRatingScale }"
                          width="2"
                          :min="question.minValue"
                          :max="question.maxValue"
                          :disabled="true"
                          :piecewiseLabel="true"
                          :piecewiseStyle="piecewiseStyle"
                          :interval="question.partitions"
                          :piecewiseActiveStyle="null"
                          :labelActiveStyle="null"
                          :dotSize="0"
                          :isNumericRatingScale="!!question.numericRatingScale"
                          :defaultSelected="false"
                        ></ds-slider>
                        <ds-slider ref="slider" v-else :value="question.minValue" direction="vertical" class="vertical-vue-slider pl-20" width="2" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="null" :dotSize="0"></ds-slider>
                        <div class="scaleLabels text-center w-120" v-if="question.verticalScale">
                          {{ question.minValueLabel }}
                        </div>
                      </div>
                    </div>

                    <div class="option-section pad-top20" v-if="question.type && question.type.toLowerCase() === 'vas'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div v-if="!question.verticalScale">
                        <div v-if="activityData && activityData.newLayout == true">
                          <div class="row">
                            <div class="col-md-3 pr-10">{{ question.minValueLabel }}</div>
                            <div class="col-md-6">
                              <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider" :width="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"> </ds-slider>
                              <div class="pt-10 scaleLabels-vas">
                                <span :style="{ 'margin-left': 15 + 'px' }">{{ question.minValue }}</span>
                                <span class="pull-right">{{ question.maxValue }}</span>
                              </div>
                            </div>
                            <div class="col-md-3">{{ question.maxValueLabel }}</div>
                          </div>
                        </div>
                        <div v-else>
                          <div class="pt-10 scaleLabels-vas">
                            <div :style="{ 'margin-left': 15 + 'px' }">
                              {{ question.minValueLabel }}
                            </div>
                            <div
                              :style="{
                                'margin-left': question.restrainLengthValue - 10 + 'mm'
                              }"
                            >
                              {{ question.maxValueLabel }}
                            </div>
                          </div>
                          <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider pl-20" :width="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                          <div class="pt-10 scaleLabels-vas">
                            <div :style="{ 'margin-left': 15 + 'px' }">
                              {{ question.minValue }}
                            </div>
                            <div
                              :style="{
                                'margin-left': question.restrainLengthValue - 10 + 'mm'
                              }"
                            >
                              {{ question.maxValue }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="question.verticalScale">
                        <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValue }}</span>
                        <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValueLabel }}</span>
                        <ds-slider ref="slider" :value="question.minValue" direction="vertical" class="vertical-vue-slider-vas pl-20" width="2" :height="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                        <div class="scaleLabels" v-if="question.verticalScale">
                          <span :style="{ 'margin-left': 30 + 'px' }">{{ question.minValue }}</span>
                          <span :style="{ 'margin-left': 30 + 'px' }">{{ question.minValueLabel }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="option-section pad-top20 pad-bottom40" v-if="question.type && question.type.toLowerCase() === 'customscale'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div v-if="!question.verticalScale">
                        <div v-if="activityData && activityData.newLayout == true">
                          <ds-slider-custom-scale ref="slider" :value="question.formattedLabels[0]" :piecewise="true" width="1" direction="horizontal" class="horizontal-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="null" :labelActiveStyle="null" :dotSize="0"></ds-slider-custom-scale>
                        </div>
                        <div v-else>
                          <ds-slider v-if="!question.verticalScale" ref="slider" :value="question.formattedLabels[0]" :piecewise="true" width="1" direction="horizontal" class="horizontal-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="null" :labelActiveStyle="null" :dotSize="0"></ds-slider>
                        </div>
                      </div>

                      <ds-slider v-if="question.verticalScale" ref="slider" :value="question.formattedLabels[0]" :piecewise="true" width="2" direction="vertical" class="vertical-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="null" :labelActiveStyle="null" :dotSize="0"></ds-slider>
                    </div>
                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'text'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <input type="text" class="input-text readonly" placeholder readonly />
                    </div>
                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'datetime'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div class="col-sm-3 p-0" v-if="question.showDate">
                        <input type="text" class="input-text readonly" placeholder v-model="question.dateFormat" readonly />
                      </div>
                      <div class="col-sm-3 p-0" v-if="question.showTime" :class="{ 'pl-10': question.showDate }">
                        <span v-if="question.timeFormat == '12'">
                          <input type="text" class="input-text readonly" placeholder value="--:-- AM" readonly />
                        </span>
                        <span v-if="question.timeFormat == '24'">
                          <input type="text" class="input-text readonly" placeholder value="--:--" readonly />
                        </span>
                      </div>
                    </div>
                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'number'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div class>
                        <input type="text" class="input-text readonly" placeholder readonly />
                      </div>
                    </div>
                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'valuepicker'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div class>
                        <input type="number" class="input-text readonly" placeholder readonly />
                      </div>
                    </div>
                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'email'">
                      <div class>
                        <input type="email" class="input-text readonly" placeholder readonly />
                      </div>
                    </div>
                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'location'">
                      <div class>
                        <input type="text" class="input-text readonly" placeholder readonly />
                      </div>
                    </div>

                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'multichoice'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div v-if="question.subType && question.subType.toLowerCase() === 'multi'">
                        <div class v-for="(option, index) in question.options" :key="index">
                          <div class="col-md-12 d-flex p-0 mb-14">
                            <input class="mt-4" type="checkbox" disabled />
                            <div class="col-md-12 pl-0">
                              <span class="ql-editor formattedColor" v-html="option.formattedBody"></span>
                            </div>
                          </div>
                          <div class v-if="option.imageUrl">
                            <img :src="option.imageUrl" alt />
                          </div>
                        </div>
                      </div>
                      <div v-if="question.subType && question.subType.toLowerCase() === 'single'">
                        <div class v-for="(option, index) in question.options" :key="index">
                          <div class="col-md-12 d-flex p-0 mb-14">
                            <input type="radio" class="mt-4" name="single" disabled />
                            <div class="col-md-12 pl-0">
                              <span class="ql-editor formattedColor" v-html="option.formattedBody"></span>
                            </div>
                          </div>
                          <div class v-if="option.imageUrl">
                            <img :src="option.imageUrl" alt class />
                          </div>
                        </div>
                      </div>
                      <div class="option-section lang-img-options" v-if="question.type && question.type.toLowerCase() === 'image'">
                        <div class="row justify-content-start">
                          <div class="col-auto pl-0 pr-0" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
                            <div class="language-name">
                              {{ langOptionobj.languageName }}
                            </div>
                            <div class="form-group clearfix" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
                              <div>
                                <span v-if="question.subType.toLowerCase() === 'multi'">
                                  <input type="checkbox" id="checkbox" disabled />
                                </span>
                                <span v-else>
                                  <input type="radio" id="radio" disabled />
                                </span>
                                <img class="col-lg-2 img-size" :src="option.imageUrl" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="option-section" v-if="question.type && question.type.toLowerCase() === 'dropdown'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div class v-for="(option, index) in question.options" :key="index">
                        <div class="col-md-12 d-flex p-0 mb-14">
                          <input type="radio" class="mt-4" name="single" disabled />
                          <div class="col-md-12 pl-0">
                            <span class="ql-editor formattedColor" v-html="option.formattedBody"></span>
                          </div>
                        </div>
                        <div class v-if="option.imageUrl">
                          <img :src="option.imageUrl" alt class />
                        </div>
                      </div>
                    </div>

                    <div class="option-section lang-img-options" v-if="question.type && question.type.toLowerCase() === 'image'">
                      <p class="question_body step-img-format ql-editor pt-0 p-0" v-html="question.formattedBody"></p>
                      <div>
                        <div class="row justify-content-start">
                          <div class="col-auto pl-0 pr-0" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
                            <div class="language-name">
                              {{ langOptionobj.languageName }}
                            </div>
                            <div class="form-group clearfix" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
                              <div>
                                <span v-if="question.subType && question.subType.toLowerCase() === 'multi'">
                                  <input type="checkbox" id="checkbox" disabled />
                                </span>
                                <span v-else>
                                  <input type="radio" id="radio" disabled />
                                </span>
                                <img class="col-lg-2 img-size" :src="option.imageUrl" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="question.subtype == 'custom'">
                  <div class="instruction_title ql-editor pt-0 p-0" v-html="question.formattedTitle" />
                  <div class="instruction_info ql-editor pt-0 p-0" v-html="question.formattedInformation" />
                  <div class="instruction_info" v-if="question.imageUrl">
                    <img class="img-size" :src="question.imageUrl" />
                  </div>
                </div>

                <div v-if="question.type == 'AudioRecording'">
                  <div class="instruction_title ql-editor pt-0 p-0" v-html="question.formattedTitle" />
                  <div class="instruction_info step-img-format ql-editor pt-6 p-0" v-html="question.formattedInformation" />
                </div>

                <div v-if="question.type == 'VideoRecording'">
                  <div class="instruction_title ql-editor pt-0 p-0" v-html="question.formattedTitle" />
                  <div class="instruction_info step-img-format ql-editor pt-6 p-0" v-html="question.formattedInformation" />
                </div>

                <div v-if="question.type == 'ValidatedEntry'">
                  <div class="text-left ql-editor pt-0 p-0" v-html="question.formattedBody" />
                </div>
                <div v-if="question.type == 'WongBaker'">
                  <div class="text-left ql-editor pt-0 p-0" v-html="question.formattedTitle" />
                  <div class="row">
                    <div class="col-md-12 p-2">
                      <img width="100%" height="250px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="wong-baker-smiley d-block text-center" alt="hurts-worse.svg" />
                      <div class="text-left pt-6 ql-editor p-0" v-html="question.formattedInformation" />
                    </div>
                  </div>
                </div>
                <div v-if="question.type == 'MedicationSelector'">
                  <div class="text-left ql-editor pt-0 p-0" v-html="question.formattedBody" />
                  <div class="col-md-12 col-sm-12 col-12 p-0 pt-15" v-if="question.content != '[]' && question.content[0] != undefined && question.content[0]['options'] != undefined">
                    <!--Start of Static Table Structure -->
                    <div class="medication_selector_table_container">
                      <div class="row table_heading">
                        <div class="col-md-4 text-center border padding">Category</div>
                        <div class="col-md-4 text-center border padding">Medication</div>
                        <div class="col-md-4 text-center border padding">Dosage</div>
                      </div>
                      <table class="medication_selector_table1">
                        <tbody>
                          <span v-for="(option, ind) in question.content[0]['options']" :key="ind">
                            <tr v-for="(dosage, index) in option['dosage']" :key="index">
                              <td v-if="index == 0">{{ option["category"] }}</td>
                              <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                              <td v-if="index == 0">{{ option["name"] }}</td>
                              <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                              <td>{{ dosage }}</td>
                            </tr>
                          </span>
                        </tbody>
                      </table>
                    </div>
                    <!--End of Static Table Structure-->
                  </div>
                </div>
                <div v-if="question.type == 'Index'">
                  <div class="question_body text-left step-img-format ql-editor pt-6 p-0" v-html="question.formattedBody" />
                </div>
                <div v-if="question.type == 'Log'">
                  <div class="question_body text-left step-img-format ql-editor pt-6 p-0" v-html="question.formattedBody" />
                </div>

                <!-- Skin Analyser Question Preview START -->
                <div v-if="question.type === 'SkinAnalyser'">
                  <div class="instruction_title ql-editor p-0" v-html="question.formattedTitle" />

                  <div class="instruction_info ql-editor pt-6 p-0" v-html="question.formattedInformation" />

                  <div class="instruction_info pt-10" v-if="question.imageUrl">
                    <img class="img-size" :src="question.imageUrl" />
                  </div>
                </div>
                <!-- Skin Analyser Question Preview END -->
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="d-flex pt-10 mt-10 mb-10">
      <div style="width: 50%">
        <a v-if="this.startIndex > 0" class="right carousel-control style-right color_blue" role="button" v-on:click="prevPage()">
          <span class="fa fa-caret-left pr-5" style="top: 2px; position: relative" aria-hidden="true"></span>
          <span class="page-next">Prev</span>
        </a>
      </div>
      <div style="width: 50%">
        <a v-if="this.activityQuestions && this.endIndex < this.activityQuestions.length" class="right carousel-control style-right color_blue float-right" role="button" v-on:click="nextPage()">
          <span class="page-next">Next</span>
          <span class="fa fa-caret-right" style="top: 2px; position: relative" aria-hidden="true"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dsSlider from "../../lib/ds-slider-component";
import dsSliderCustomScale from "@/lib/ds-slider-component-custom-scale";

export default {
  name: "qaCard",
  data() {
    return {
      selectedActivityQuestion: { id: null },
      activityId: null,
      activityQuestions: [],
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      isDisabled: false,
      startIndex: 0,
      endIndex: 5
    };
  },
  props: ["activityData", "activeEditGroup"],
  components: { dsSlider, dsSliderCustomScale },
  mounted() {
    this.startIndex = 0;
    this.endIndex = 5;
    this.activityId = this.$route.params.activityId;
    if (this.activityData && this.activityData.questions) {
      for (let i = 0, seq = 1; i < this.activityData.questions.length; i++) {
        if (this.activityData.questions[i].type && this.activityData.questions[i].type != "Section") {
          this.activityData.questions[i].stepSequence = seq++;
        }
      }
      this.activityQuestions = this.activityData.questions;
    }
  },
  computed: {
    selectedActivityQuestionChange() {
      return this.$store.getters.getActivitySelectedQuestion;
    },
    questions() {
      return this.$store.getters.getActivityQuestionsData;
    },
    getLastModifiedActivityQuestion() {
      return this.$store.getters.getLastModifiedActivityQuestion;
    }
  },
  watch: {
    selectedActivityQuestionChange: {
      handler(val) {
        this.selectedActivityQuestion = val;
        if (this.selectedActivityQuestion.type == "CustomScale") {
          if (!this.selectedActivityQuestion.scores) {
            this.selectedActivityQuestion.scores = [];
          }
        }
        if (val && val.type === "Section" && !val.hasOwnProperty("id")) {
          return;
        }
        if (!(val && val.hasOwnProperty && val.hasOwnProperty("id") && val.id)) {
          this.$emit("update:activeEditGroup", null);
        }
      }
    },
    questions: {
      handler(val) {
        this.startIndex = 0;
        this.endIndex = 5;
        this.activityQuestions = val;
        for (let i = 0, seq = 1; i < this.activityQuestions.length; i++) {
          if (this.activityQuestions[i].type && this.activityQuestions[i].type != "Section") {
            this.activityQuestions[i].stepSequence = seq++;
          }
        }
        // when any change happens on the page bcoz of either by drag drop / deleting question or etc, scale que. design gets disturbed
        // so the below code refreshed the scale question designs.
        this.$nextTick(function() {
          if (this.$refs.slider) {
            this.$refs.slider.forEach((slide, i) => {
              this.$refs.slider[i].refresh();
            });
          }
        });
      }
    }
  },
  methods: {
    nextPage() {
      if (this.endIndex > this.activityQuestions.length) {
        return;
      }
      this.startIndex = this.endIndex;
      this.endIndex += 5;
    },
    prevPage() {
      if (this.startIndex <= 0) {
        return;
      }
      this.endIndex = this.startIndex;
      this.startIndex -= 5;
    },
    // measurement placeholder
    getplaceholdertext(question) {
      if (question.subType == "weight") {
        return "Enter weight";
      } else if (question.subType == "height") {
        return "Enter height/length";
      } else if (question.subType == "bloodpressure") {
        return "Enter blood pressure";
      } else if (question.subType == "measurements") {
        return "Enter value here";
      } else if (question.subType === "temperature") {
        return "Enter temperature";
      }
    }
  }
};
</script>

<style scoped lang="scss">
h1,
h2,
h3 {
  font-weight: 200;
}
.wid300 {
  max-width: 300px !important;
}
.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.question_body {
  word-break: break-all;
  color: #959fa4;
}

.read_only_question {
  border-left: 1px solid #d3dfe4 !important;
  background-color: #f5f8fa;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

// Style for quick fixes bootstrap after migration (before redesign should be removed)

.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
  .col-sm-3 {
    float: left;
  }
}

// END of style for quick fixes bootstrap after migration (before redesign should be removed)

h1,
h2,
h3 {
  font-weight: 200;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.question_body {
  word-break: break-all;
  color: #959fa4;
}

.read_only_question {
  border-left: 1px solid #d3dfe4 !important;
  background-color: #f5f8fa;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  color: #57dd7a;
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 30px;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.pad-top50 {
  padding-top: 50px;
}

.form-control {
  border-radius: 2px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.readonly {
  background: #f7f7f7;
}
.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.text-color {
  color: #888;
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}
.branching_section {
  // background-color: #f5f8fa;
  // border: solid 1px #d3dfe4;
  padding: 5px 0px;
  .branching_image {
    max-width: 120px;
    max-height: 120px;
    width: 100%;
    border: 1px solid #ccc;
  }
}
.custom-btn-bg {
  background: linear-gradient(to left, #4b6fe6, #00baf9);
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.pad-left100 {
  padding-left: 100px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 15px;
  margin-bottom: 16px;
}

.question_color,
input {
  color: #666769;
  font-size: 14px;
}

.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}

.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.date-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.pad-top20 {
  padding-top: 20px;
}

.pad-bottom40 {
  padding-bottom: 40px;
}

.vertical-vue-slider {
  height: auto;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.vertical-vue-slider-vas {
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.horizontal-vue-slider {
  height: 8px;
  width: 100%;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  max-width: 120px;
  max-height: 120px;
  padding-left: 5px;
}

label {
  font-weight: normal !important;
  word-break: break-all;
  color: #959fa4;
}

.modal-dialog {
  width: 500px !important;
}

.instruction_title {
  word-break: break-all;
  font-size: 18px;
  font-weight: bold;
}
.instruction_info {
  word-break: break-all;
}

.edit_button {
  background-color: #ffffff;
  border: 1px solid #d3dfe4;
  font-size: 12px;
}

.drag_img {
  position: relative;
  bottom: 1px;
  margin-right: 6px;
}

.scaleLabels {
  font-size: 12px;
  color: #666669;
}

.scaleLabels-vas {
  font-size: 12px;
  color: #666669;
  width: 100px;
  display: flex;
  justify-content: space-between;
}

.display-inline {
  display: inline-block;
  padding-left: 5px;
}
/deep/ .vue-slider-component .vue-slider-tooltip {
  display: none;
}
input[type="radio"] {
  vertical-align: middle;
}

#reorderingModal {
  .move-btn {
    background-color: #4c8ce4;
    border-color: #4c8ce4;
    border-radius: 20px;
    padding: 5px 30px;
  }
  button.close {
    margin-top: -2px;
  }
  .modal-title {
    font-size: 15px;
    font-weight: bold;
  }
  .invalid-feedback {
    display: block;
    font-size: 13px;
    max-width: 165px;
  }
}

.lang-img-options .col-auto {
  margin-right: 126px !important;
}

.lang-img-options .col-auto:last-of-type {
  margin-right: 0 !important;
}

.language-name {
  color: #959fa4;
}

.group-scoring {
  &__container {
    border-radius: 3px;

    &-empty {
      border: dotted 1px #b0bac9;
      background-color: #ffffff;
      height: 30px;
      padding: 5px 13px;
    }

    &-filled,
    &-edit {
      border: solid 1px #b0bac9;
      background-color: #b0bac9;
      height: 40px;
      padding: 10px 13px;
    }

    &-only-display {
      height: 30px;
    }
  }

  &__name-input {
    flex-basis: 75%;
  }
}
.section_weight {
  background-color: #eee;
  border-radius: 3px;
  color: #000;
  line-height: 26px;
  padding: 0 10px;
  text-align: right;
}
.branching-border {
  border-top: 1px solid #d3dfe4;
  // border-bottom: 1px solid #d3dfe4;
}
.clearbranchimage {
  vertical-align: middle;
  padding: 3px;
  border: 1px solid #d3dfe4;
  background: #d3dfe4;
  opacity: 0.6;
  border-radius: 3px;
}
.branchingsavebtn {
  width: 88px;
  border-radius: 4px;
  background-color: #4c8ce4;
  border-radius: 2px solid #4c8ce4;
  display: flex;
  justify-content: center;
  padding: 6px;
  cursor: pointer;
}
.branchingbtntext {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
}
.cancelbranchingbtn {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
  margin: 14px;
  cursor: pointer;
}
.branchingsteptitalname {
  font-size: 18px;
  line-height: 1.33;
  letter-spacing: normal;
  color: #000000;
}
.branchingstep {
  padding: 20px 5px 5px 20px;
}
.branchingstepcount {
  font-size: 14px;
  color: #000000;
  font-weight: bold;
}
.beanchinglogictext {
  font-size: 14px;
  color: #000000;
}
.Add_another_branch {
  font-size: 12px;
  font-weight: bold;
  color: #4c8ce4;
  cursor: pointer;
}
.branchingsteptitalname p {
  margin-bottom: 0;
}
.branching-select-option {
  width: 50px;
  height: 23px;
  border-radius: 3px;
  font-size: 12px;
  border: solid 1px #d3dfe4;
  padding-top: 1px;
}
.priority-no {
  position: relative;
  top: 13px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
.priority-img {
  opacity: 0.6;
}
.rotate-180deg {
  transform: rotate(180deg);
}
.page-next {
  line-height: 1.14;
  padding-right: 5px;
}
.carousel-control {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  width: 18%;
  font-size: 14px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.medication_selector_table_container {
  min-height: 150px;
  width: 385px;
  border: 1px solid #d3dfe4;
  border-radius: 6px 6px 0 0;
  background: rgba(245, 245, 245, 0.3);
  margin: 24px 0 0 56px;
}
.medication_selector_table1 {
  font-size: 12px;
  color: #666669;
  border-color: #ddd;
  width: 100%;
  border: none;
  margin: 5px 5px 0;
}
.medication_selector_table1 td {
  border: 1px solid #dee2e6;
  background: #fff;
  font-size: 12px;
  color: #666669;
  width: 124px;
  padding: 0.544rem 0.75rem !important;
  text-align: center;
}
.medication_selector_table1 tbody {
  max-height: 151px;
  width: 373px;
  display: block;
  overflow: auto;
}
.table_heading {
  width: 383.7px;
  background: #d3dfe4;
  border-radius: 6px 6px 0 0;
  font-size: 12px;
  color: #ffffff;
  margin-left: -0.5px !important;
}
.padding {
  padding: 3px 0 1px;
}
/*End of styles for static medication selector table*/

.medication_selector_table {
  font-size: 12px;
  border-color: #ddd;
  min-height: 150px;
  width: 385px;
  border: none;
  margin: 0.5625rem 0rem 0rem 3.625rem;
}
.medication_selector_table tbody {
  max-height: 151px;
  overflow: scroll;
  margin: 10px;
}
.medication_selector_table td {
  border: 1px solid #dee2e6;
  background: #fff;
  padding: 0.544rem 0.75rem;
  text-align: center;
}
.bordered {
  border: 1px solid #cccccc;
  border-radius: 6px 6px 6px 6px;
  -moz-border-radius: 6px 6px 6px 6px;
  -webkit-border-radius: 6px 6px 6px 6px;
}
.medication_selector_table th:first-child {
  border-radius: 6px 0 0 0;
  -moz-border-radius: 6px 0 0 0;
  -webkit-border-radius: 6px 0 0 0;
  background-color: #d3dfe4;
  color: #ffffff;
  text-align: center;
  padding: 0.165rem 0.75rem;
}
.medication_selector_table th:last-child {
  border-radius: 0 6px 0 0;
  -moz-border-radius: 0 6px 0 0;
  -webkit-border-radius: 0 6px 0 0;
  background-color: #d3dfe4;
  color: #ffffff;
  text-align: center;
  padding: 0.165rem 0.75rem;
  /deep/ .instruction_info p {
    margin-bottom: 0rem !important;
  }
}
/deep/ .step-img-format {
  img {
    max-width: 120px;
    max-height: 120px;
  }
}
.wong-baker-count-box {
  width: 50px;
  height: 59px;
  padding: 19px 17px;
  margin: 9px auto;
  border-radius: 8px;
  border: solid 1px #b0bac9;
}
.wong-baker-count-box .count-text {
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  line-height: 0.92;
  letter-spacing: -0.41px;
  text-align: center;
  color: #666669;
}
.label {
  width: 100%;
  max-width: 60px;
}
.v-number-scale-steps {
  height: 300px !important;
}
.formattedColor {
  color: #9b9fa4;
  display: block !important;
  padding: 0px !important;
  padding-left: 5px !important;
}
.right-label {
  position: relative;
  left: 2px;
}
</style>
